import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true, error });

    // Log to our error logging server
    const errorUrl = import.meta.env.VITE_ERROR_LOGGING_URL;
    if (!errorUrl) return;
    fetch(errorUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: error.message,
        source: errorInfo.componentStack,
        error: { stack: error.stack },
        url: window.location.href,
        timestamp: new Date().toISOString(),
        type: 'react-component-error',
        componentStack: errorInfo.componentStack
      })
    }).catch(e => console.log('Failed to log error:', e));
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;